import { colors, fonts } from 'app-v2/design-systems'
import { BORDER, COLOR, SPACING, TEXT } from 'app-v2/design-tokens'
import React, { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import downIcon from 'app/tu-preferes-king/assets/Down_icon.png'
import type { GoodieDTO } from 'shared/store/tu-preferes-king'
import { useIntl } from 'react-intl'
import { StyledDropdownItem } from '../styles'
import { breakpoints } from 'app/assets/styles'

export function GiftSelector({
    goodies,
    setGoodie,
    isMenuOpen,
    setIsMenuOpen,
    setIsOtherMenuOpen
}: {
    goodies: GoodieDTO[],
    setGoodie: (s: GoodieDTO) => void,
    isMenuOpen: boolean,
    setIsMenuOpen: (b: boolean) => void,
    setIsOtherMenuOpen: (b: boolean) => void
}) {
    const intl = useIntl()

    const [width, setWidth] = useState(window.innerWidth)
    const isSmallScreen = width < breakpoints.xsmallLegacy

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions)
        document.addEventListener('click', handleClickOutside)
        return () => {
            window.removeEventListener('resize', updateWindowDimensions)
            document.removeEventListener('click', handleClickOutside)
        }
    }, [])

    const containerRef = useRef(null)

    const updateWindowDimensions = () => setWidth(window.innerWidth)

    const [inputText, setInputText] = useState(
        intl.formatMessage({
            id: 'tupreferesking.goodies.selectGainCaption'
        })
    )
    const [inputTextColor, setInputTextColor] = useState(colors.greyBbqBrown)

    const handleClick = () => {
        setIsMenuOpen(!isMenuOpen)
        setIsOtherMenuOpen(false)
    }

    const handleSelectGoodie = selectedGoodie => {
        setGoodie(selectedGoodie)
        setInputText(selectedGoodie.name)
        setInputTextColor(COLOR.PRIMARY)
        setIsMenuOpen(!isMenuOpen)
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (
            containerRef.current &&
            !containerRef.current.contains(event.target)
        ) {
            setIsMenuOpen(false)
        }
    }

    return (
        <GiftSelectorInput
            ref={containerRef}
            onClick={handleClick}
            isSmallScreen={isSmallScreen}>
            <StyledInputText inputTextColor={inputTextColor}>
                {inputText}
            </StyledInputText>
            <StyledIcon
                src={downIcon}
                isRotated={isMenuOpen}
                isSmallScreen={isSmallScreen}
            />
            {isMenuOpen && (
                <DropdownMenu isSmallScreen={isSmallScreen}>
                    {goodies.map(goodie => (
                        <StyledDropdownItem
                            key={goodie.id}
                            onClick={() => handleSelectGoodie(goodie)}>
                            {goodie.name}
                        </StyledDropdownItem>
                    ))}
                </DropdownMenu>
            )}
        </GiftSelectorInput>
    )
}

const GiftSelectorInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: ${BORDER.RADIUS.M};
    padding: ${SPACING.XXXS} ${props => (props.isSmallScreen ? 0 : SPACING.XS)}
        ${SPACING.XXS} 0;
    width: ${props => (props.isSmallScreen ? '100%' : '50%')};
    background: ${colors.white};
    border: 1px solid ${colors.lightGrey};
    min-height: 30px;
    max-height: 30px;
`

export const StyledInputText = styled.span`
    font-family: ${TEXT.FONT_FAMILY.DEFAULT_SANS};
    color: ${props => props.inputTextColor};
    padding: 0 ${SPACING.M};
    font-size: ${TEXT.FONT_SIZE.M};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: ${SPACING.XXXS};
`

const StyledIcon = styled.img`
    margin-left: auto;
    margin-right: ${props =>
        props.isSmallScreen ? SPACING.XXS : SPACING.XXXS};
    align-self: center;
    transform: ${props => (props.isRotated ? 'rotate(180deg)' : 'none')};
    transition: transform 0.3s ease-in-out;
    cursor: pointer;
    margin-top: ${SPACING.XXXS};
`

const DropdownMenu = styled.ul`
    position: absolute;
    top: calc(100% + 5px);
    left: 0;
    width: calc(100% - 5px);
    background: ${colors.white};
    border: 1px solid ${colors.lightGrey};
    max-height: 200px;
    overflow-y: auto;
    z-index: 1;
`
